import { MockFrame } from 'react-mockframe';
import 'react-mockframe/styles/mockframe.css';

export type DeviceType = 'macbook' | 'ipad' | 'iphone' | 'android';

const SCREEN_ASSETS = {
  macbook: 'https://hello-gwiji.fra1.cdn.digitaloceanspaces.com/website/mac.avif',
  ipad: 'https://hello-gwiji.fra1.cdn.digitaloceanspaces.com/website/ipad.avif',
  iphone: 'https://hello-gwiji.fra1.cdn.digitaloceanspaces.com/website/iphone.avif',
  android: 'https://hello-gwiji.fra1.cdn.digitaloceanspaces.com/website/android.avif',
} as const satisfies Record<DeviceType, string>;

interface DeviceFrameProps {
  type: DeviceType;
  accent?: string;
  label?: string;
  /** Optional screen image override (defaults to device stock asset) */
  src?: string;
}

function DeviceScreenImage({ src, alt, type }: { src: string; alt: string; type: DeviceType }) {
  return (
    <img
      src={src}
      alt={alt}
      className={`device-frame__screen-img device-frame__screen-img--${type}`}
      loading="lazy"
      decoding="async"
    />
  );
}

export function DeviceFrame({ type, label, src }: DeviceFrameProps) {
  const screenSrc = src ?? SCREEN_ASSETS[type];
  const alt = label ?? `Hello Gwiji on ${type}`;
  const screen = <DeviceScreenImage src={screenSrc} alt={alt} type={type} />;

  return (
    <div className={`device-frame device-frame--${type}`} aria-label={alt}>
      {type === 'macbook' && (
        <MockFrame device="MacBook Pro" color="silver" className="device-frame__mock">
          {screen}
        </MockFrame>
      )}

      {type === 'ipad' && (
        <MockFrame
          device="iPad Pro"
          color="silver"
          landscape
          width={512}
          height={734}
          className="device-frame__mock device-frame__mock--ipad-pro-13"
        >
          {screen}
        </MockFrame>
      )}

      {type === 'iphone' && (
        <MockFrame device="iPhone 17" color="white" className="device-frame__mock">
          {screen}
        </MockFrame>
      )}

      {type === 'android' && (
        <MockFrame device="Galaxy S25" color="silver" className="device-frame__mock">
          {screen}
        </MockFrame>
      )}
    </div>
  );
}
